import { Recipe } from '@/types/recipe';

export interface ImportSource {
  label: string;
  url: string;
}

export function getImportSource(recipe: Pick<Recipe, 'sourceUrl' | 'scrapeMethod'>): ImportSource | null {
  if (!recipe.sourceUrl) return null;

  const url = recipe.sourceUrl;
  let label: string;

  if (recipe.scrapeMethod === 'instagram') {
    label = 'Instagram';
  } else if (recipe.scrapeMethod === 'tiktok') {
    label = 'TikTok';
  } else {
    try {
      label = new URL(url).hostname.replace(/^www\./, '');
    } catch {
      label = url;
    }
  }

  return { label, url };
}
